import { useEffect, useState } from 'react';
import type { MeResponse, OutletRef } from '@kassa/shared';
import { api, ApiError } from '../api';

interface Props {
  onSelected: (me: MeResponse) => void;
  onLogout: () => void;
}

// Obyekt seçimi. Yalnız bir obyekt varsa avtomatik seçilir.
export function SelectOutlet({ onSelected, onLogout }: Props) {
  const [outlets, setOutlets] = useState<OutletRef[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  async function choose(outletId: string) {
    setBusy(outletId);
    setError(null);
    try {
      onSelected(await api.selectOutlet({ outletId }));
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Şəbəkə xətası. Yenidən cəhd edin.');
      setBusy(null);
    }
  }

  useEffect(() => {
    api
      .outlets()
      .then((list) => {
        setOutlets(list);
        if (list.length === 1) void choose(list[0].id);
      })
      .catch((err: unknown) => {
        setError(err instanceof ApiError ? err.message : 'Obyektlər yüklənmədi');
      });
    // yalnız ilk yükləmədə
    // (choose sabit funksiyadır — onSelected App-dən gəlir)
  }, []);

  return (
    <div className="page-center">
      <div className="card card-wide">
        <h2>Obyekt seçin</h2>
        {outlets === null && !error && <p className="muted">Yüklənir…</p>}
        {outlets !== null && outlets.length === 0 && (
          <p className="muted">Bu hesaba bağlı obyekt yoxdur. Sahibinizlə əlaqə saxlayın.</p>
        )}
        {outlets !== null && outlets.length > 1 && (
          <ul className="choice-list">
            {outlets.map((o) => (
              <li key={o.id}>
                <button type="button" className="choice" onClick={() => choose(o.id)} disabled={busy !== null}>
                  <span className="choice-title">{o.name}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
        {error && (
          <p className="bad" role="alert">
            {error}
          </p>
        )}
        <button type="button" className="link-btn" onClick={onLogout}>
          Çıxış
        </button>
      </div>
    </div>
  );
}
